import styled from "@emotion/styled";
import { Card, Col, Row, Tabs, Typography } from "antd";
import { goBack } from "assets/icons/index";
import { useNavigate } from "react-router-dom";

import RequireApprove from "./RequireApprove";
import { useRequireApprovePoint } from "hooks/usePoint";
import { useAppSelector } from "store";

const PointManage = () => {
  const navigate = useNavigate();

  const constact = useAppSelector((state) => state.auth.contact);

  const { data: dataRequireApprovePoint } = useRequireApprovePoint({
    search: "",
    offset: 0,
    limit: 1,
    factory_id: constact?.id || "",
  });

  const items = [
    {
      // (${inprosessItems?.length || 0})
      label: `รอการยืนการเติม Point (${
        dataRequireApprovePoint?.data?.total_record ?? 0
      })`,
      key: "1",
      children: (
        // <WaitingPaymentTable data={undefined}/>
        <RequireApprove />
      ),
    },
  ];

  return (
    <>
      <Card bordered={false} className="criclebox h-full tabs-mobile">
        <HeaderTabs>
          <IconWrapper
            onClick={() => {
              //navigate("/setting");
            }}
          >
            <SpanIcon>{goBack}</SpanIcon>
          </IconWrapper>
          <Typography.Title level={5}>จัดการ Point</Typography.Title>
          <RightIconWrapper></RightIconWrapper>
        </HeaderTabs>
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col sm={24} md={24}>
            <Tabs
              defaultActiveKey={"0"}
              style={{ height: "100%" }}
              items={items}
              key="key"
            />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default PointManage;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
